import { render, staticRenderFns } from "./QuoteTradeInputs.vue?vue&type=template&id=6e83496a&scoped=true&"
import script from "./QuoteTradeInputs.vue?vue&type=script&lang=js&"
export * from "./QuoteTradeInputs.vue?vue&type=script&lang=js&"
import style0 from "./QuoteTradeInputs.vue?vue&type=style&index=0&id=6e83496a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e83496a",
  null
  
)

export default component.exports